export default __webpack_public_path__ + "static/media/bg6.aa9909fb.png";